import {FC} from 'react';
import { Navigate, Outlet } from 'react-router';

export const AuthRoutes: FC = () => {

    const token = localStorage.getItem('token');

    return !token ? <Navigate to={'/login'}/> : <Outlet/>;
}